import React, { forwardRef, memo } from 'react';
import type { ButtonProps } from '@theme-ui/components';
import { Spinner, Button, Row, Box } from './core';
import { ITxStatus } from '@sc1/common/utils';

const { PENDING } = ITxStatus;

interface StatusButtonProps extends Omit<ButtonProps, 'prefix'> {
  status: ITxStatus | undefined;
  disabled?: boolean;
  suffix?: JSX.Element | null;
}

export const StatusButton = memo(
  forwardRef<HTMLButtonElement, StatusButtonProps>(
    ({ status, children, disabled, suffix, ...props }, ref) => {
      const _suffix =
        status === PENDING ? <Spinner strokeWidth={4} size={16} /> : suffix;
      const _disabled = disabled ?? status === PENDING;
      return (
        <Button
          variant="statusButton"
          disabled={_disabled}
          ref={ref}
          {...props}
        >
          <Row
            sx={{
              textAlign: 'center',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box mr={_suffix ? 1 : 0}>{children}</Box>
            {_suffix}
          </Row>
        </Button>
      );
    }
  )
);
